import { Component } from 'react';
import PropTypes from 'prop-types';

export default class Marker extends Component {
  constructor(props) {
    super(props);
    this.shape = null;
  }

  componentWillMount() {
    // Throw warning if map, maps,. handelboudns havnet been defined

    const position = { lat: this.props.coordinates.lat, lng: this.props.coordinates.lng };
    this.shape = new this.props.maps.Marker({
      clickable: !!this.props.info,
      icon: {
        scale: this.props.scale,
        strokeColor: this.props.strokeColor,
        strokeOpacity: this.props.strokeOpacity,
        strokeWeight: this.props.strokeWeight,
        fillColor: this.props.fillColor,
        fillOpacity: this.props.fillOpacity,
        ...this.props.icon,
      },
      map: this.props.map,
      position,
    });

    if (this.props.info) {
      this.infoWindow = new this.props.maps.InfoWindow({
        content: this.props.info.content,
        position,
      });
      this.openInfoWindow = () => this.infoWindow.open(this.props.map, this.shape);

      this.shape.addListener('click', this.openInfoWindow);
    }

    this.props.handleBounds(this.getBounds(position));
    this.shape.setMap(this.props.map);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.map !== nextProps.map) {
      this.shape.setMap(nextProps.map);
    }

    if (this.props.coordinates.lat !== nextProps.coordinates.lat ||
      this.props.coordinates.lng !== nextProps.coordinates.lng) {
      const position = { lat: nextProps.coordinates.lat, lng: nextProps.coordinates.lng };
      this.shape.setPosition(position);

      if (this.props.info && this.infoWindow) {
        this.infoWindow.setPosition(position);
      }

      this.props.handleBounds(this.getBounds(position));
    }
  }

  componentWillUnmount() {
    this.props.handleBounds(null);
    this.shape.setMap(null);
  }

  getBounds = position => (new this.props.maps.LatLngBounds()).extend(position);

  render() {
    return null;
  }
}

Marker.defaultProps = {
  info: undefined,
  scale: 0.4,
  strokeColor: '#0A95FF',
  strokeOpacity: 1,
  strokeWeight: 2,
  fillColor: '#0A95FF',
  fillOpacity: 0.7,
};

Marker.propTypes = {
  coordinates: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  handleBounds: PropTypes.func.isRequired,

  // Info
  info: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),

  // Styling
  icon: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,

  scale: PropTypes.number,
  strokeColor: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWeight: PropTypes.number,
  fillColor: PropTypes.string,
  fillOpacity: PropTypes.number,

  // Google Maps map instance
  map: PropTypes.object.isRequired, // eslint-disable-line
  // Google Maps lib reference
  maps: PropTypes.object.isRequired, // eslint-disable-line
};
